<template>
  <div class="card-wrapper">
  <v-container fluid grid-list-md class="px-0 py-0">
    <v-data-iterator
      content-tag="v-layout"
      row
      wrap
      :items="items"
      :pagination.sync="sorter"
      :total-items="totalCount"
      :rows-per-page-items="[12, 24, 32]"
    >
      <v-flex
        slot="item"
        slot-scope="props"
        xs12
        sm6
        md4
        lg3
      >
        <CardItem
          :item="props.item"
          :selection="selection"
          :emitSelection="emitSelection"
          :headers="usableHeaders"
          :actions="actions"
          :hasActions="hasActions"
          />
      </v-flex>
    </v-data-iterator>
  </v-container>
  </div>

</template>

<script>
import CardItem from '@/components/list/CardItem'
import _ from 'lodash'

export default {
  components: {
    CardItem,
  },
  props: {
    items: Array,
    unfiltered: Array,
    emitSelection: Function,
    handleSort: Function,
    updatePagination: Function,
    selection: Array,
    pagination: Object,
    headers: Array,
    actions: Array,
    hasActions: Boolean,
    totalCount: Number,
  },
  computed: {
    usableHeaders () { return _.reject(this.headers, {card: false}) },
    sorter: {
      get () { return this.pagination },
      set (value) { this.updatePagination(value) },
    },
  },
}
</script>

<style>
</style>
